import { render, staticRenderFns } from "./orderErrDialog.vue?vue&type=template&id=995fdffc&scoped=true&"
import script from "./orderErrDialog.vue?vue&type=script&lang=js&"
export * from "./orderErrDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderErrDialog.vue?vue&type=style&index=0&id=995fdffc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995fdffc",
  null
  
)

export default component.exports